module.exports = __webpack_public_path__ + "src/assets/ba.8091f007.png";